module.exports = __webpack_public_path__ + "img/search.b844111a.svg";